// utils/navigation-behavior.js
export function initNavigationBehavior({
    overlaySelector = "#Overlay",
    skipToContentSelector = "#SkipToContent",
} = {}) {

    // 1) Remove overlay "active" on DOM ready
    const overlay = document.querySelector(overlaySelector);
    overlay?.classList.remove("active");

    // 2) Skip-to-content click: prevent jump + focus the target
    const skip = document.querySelector(skipToContentSelector);
    if (skip) {
        skip.addEventListener("click", (e) => {
            e.preventDefault();

            const targetSelector = skip.getAttribute("href");
            if (!targetSelector) return;

            const target = document.querySelector(targetSelector);
            if (!target) return;

            // Ensure focus works for non-focusable elements
            if (!target.hasAttribute("tabindex")) {
                target.setAttribute("tabindex", "-1");
            }

            target.focus({ preventScroll: false });
        });
    }

    // 3) Manual scroll restoration (same behavior)
    if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual";
    }

    // 4) jumpToHash + re-run on hashchange (uses your existing global function)
    if (typeof window.jumpToHash === "function") {
        window.jumpToHash();
        window.addEventListener("hashchange", () => window.jumpToHash());
    }
}
